/*
 *  Links List - Create a list of links, and then share it!
 *  Copyright (c) Luke Denton
 *
 *  This program is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation; either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import Vue from 'vue';
import VueResource from 'vue-resource';
import VueClipboard from 'vue-clipboard2';
import Bugsnag from 'bugsnag-js';
import VueBugsnag from 'vue-bugsnag';
import Ads from 'vue-google-adsense';
import LogRocket from 'logrocket';
import './plugins/vuetify';
import Wrapper from './Wrapper.vue';
import store from '@store';
import appConfig from '@/application-configuration';
import router from './router';
import { auth, db } from "@/utils/FirebaseListeners";
import tables from "../functions/tables.json";

Vue.config.productionTip = false;

Bugsnag.apiKey = "9fe8522314d114ca836fb884f2ea2165";

Vue.use(require('vue-script2'));
Vue.use(VueResource);
Vue.use(VueClipboard);

Vue.use(Ads.InFeedAdsense);

if (appConfig.isLive) {
  Vue.use(VueBugsnag);
  LogRocket.init('v0ublt/links-list');
}

store.dispatch('checkIfCookiesAllowed');

auth.onAuthStateChanged((user) => {
  if (!user || !store.getters.areCookiesAccepted) {
    store.dispatch('user', { user: false });
    return;
  }

  db.ref(`/${tables.users}/${user.uid}`).once('value', (snapshot) => {
    const val = snapshot.val();
    const lastUpdateId = val?.lastUpdateId ? val.lastUpdateId : '1.6.4' // Use 1.6.4 as fallback, as that was the last update before implementing latest updates dialog
    const linksListUser = {
      ...user,
      custom: {
        ...val,
        lastUpdateId
      }
    };

    store.dispatch('user', { user: linksListUser });
    store.dispatch('setLatestUpdates', { lastUpdateId });

    if (appConfig.isLive) {
      LogRocket.identify(linksListUser.uid, {
        email: linksListUser.email
      });
    }
  });

});

// @TODO This probably needs to be updated to run a regex pattern over the location.pathname, using `.some()`, as we'll also need to account for /update/some-update-name
const urlHasListId = !['/', '/app', '/updates'].includes(location.pathname);
if (store.getters.areCookiesAccepted) {
  if (urlHasListId) {
    store.dispatch('setAreLinksLoading', { isLoading: true });

    setTimeout(() => {
      // If a list is loaded that doesn't have any links, then this will be the only way that the loader will be removed
      store.dispatch('setAreLinksLoading', { isLoading: false });
    }, 500)
  } else {
    store.dispatch('checkAndHydrateFromLocalStorage');
  }
}

new Vue({
  store,
  router,
  render: h => h(Wrapper)
}).$mount('#app');

window.prerenderReady = true;
